import { render } from "./VideoLink.vue?vue&type=template&id=eef72020&scoped=true"
import script from "./VideoLink.vue?vue&type=script&lang=js"
export * from "./VideoLink.vue?vue&type=script&lang=js"

import "./VideoLink.vue?vue&type=style&index=0&id=eef72020&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef72020"]])

export default __exports__